export { default as PermissionList } from './List';
